import { render, staticRenderFns } from "./CreatePform.vue?vue&type=template&id=869616a8"
import script from "./CreatePform.vue?vue&type=script&lang=js"
export * from "./CreatePform.vue?vue&type=script&lang=js"
import style0 from "./CreatePform.vue?vue&type=style&index=0&id=869616a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports